(() => {
	let isScriptLoaded = false;

	async function init(vouchers = false) {
		// Add stripe js if not already loaded
		if (!isScriptLoaded) {
			await loadScript('https://js.stripe.com/v3/');
			isScriptLoaded = true;
		}

		// const stripe = Stripe('pk_test_51H7bZVIuYwdGyLt82SGbdBaJoAOHw1jTV4wvImUZTEsZBaMjV603glmoQGZRmuMl9Dkd3wHvJraSCAoioifQG8Xs0024NBb0k2');
		const stripe = Stripe('pk_live_51H7bZVIuYwdGyLt8zfeGTxg1QT8ArbnAfuzmyX1ptoNjUtJ8lfF7nYhdJptApVTNIanUb8kutqCJFMIrF915lYgj008mhGq3yI');
		const elements = stripe.elements();
		const card = elements.create('card', {
			hidePostalCode: true,
			style: {
				base: {
					'color': '#043a56',
					'fontFamily': 'Arial, sans-serif',
					'fontSmoothing': 'antialiased',
					'fontSize': '16px',
					'::placeholder': {
						color: '#043a56'
					}
				},
				invalid: {
					fontFamily: 'Arial, sans-serif',
					color: '#cc7268',
					iconColor: '#cc7268'
				}
			}
		});

		const form = document.querySelector('#payment-form');
		const total = document.querySelector('#total');
		const btn = document.querySelector('#submit');
		const error = document.querySelector('#card-error');
		const result = document.querySelector('#result');
		const json = {
			orderId: parseInt(form.dataset.id),
			vouchers: []
		};

		loading(true);

		if (vouchers) {
			vouchers.each(function (i, e) {
				json.vouchers.push($(this).val())
			});
		}

		const data = await fetch(`${ROOT}admin/extension/stripe/payment/`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(json)
		}).then((res) => {
			return res.json();
		});

		if (data.error) {
			alert('There was an error trying to calculate the total or your order. Please refresh and try again, or contact Blueskin Nurseries');
			return false;
		}

		if (data.total <= 0) {
			$BODY.find('.payment__voucher input:not(:checked)').prop('disabled', true);
		}
		else {
			$BODY.find('.payment__voucher input:not(:checked)').prop('disabled', false);
		}

		const formatted_total = new Intl.NumberFormat('en-NZ', {
			style: 'currency',
			currency: 'NZD',
			minimumFractionDigits: 2
		}).format(data.total / 100);

		total.textContent = `Total to pay: ${formatted_total}`;

		if (data.payment === 'no_charge') {
			card.unmount('#card-element');
			$('.form-group').addClass('no-charge');
		}
		else {
			card.mount('#card-element');
			$('.form-group').removeClass('no-charge');
		}

		loading(false);

		// Events
		// ----------------------------------------

		card.on('change', (e) => {
			btn.disabled = false;
			error.textContent = e.error ? e.error.message : '';
		});

		form.addEventListener('submit', (e) => {
			e.preventDefault();
			payWithCard(stripe, card, data.clientSecret);
		});

		// Func
		// ----------------------------------------

		async function payWithCard(stripe, card, clientSecret) {
			loading(true);

			if ($('.form-group').hasClass('no-charge')) {
				orderComplete('no-charge');
				return false;
			}

			const email = document.getElementById('input-email');
			const options = {
				payment_method: {
					card: card
				}
			};

			if (email && email.value) {
				options.receipt_email = email.value;
			}

			const res = await stripe.confirmCardPayment(clientSecret, options);

			if (res.error) {
				showError(res.error.message);
			} else {
				orderComplete(res.paymentIntent);
			}
		}

		// Shows a success message when the payment is complete
		async function orderComplete(paymentIntent) {
			/*
			 *	Trigger Event for saving data and sending receipt to customer
			 */
			let form = document.querySelector('#payment-form');

			// Update order
			const data = new FormData();
			data.append('id', form.dataset.id);
			data.append('fields[order-status]', 'Paid');
			data.append('fields[stripe-receipt]', (typeof paymentIntent === 'object') ? JSON.stringify(paymentIntent) : '');
			data.append('fields[vouchers]', (json.vouchers.length) ? JSON.stringify(json.vouchers) : '');
			data.append('fields[date-paid]', 'now');
			data.append('fields[transaction-status]', (typeof paymentIntent === 'object') ? paymentIntent.status : 'Paid with vouchers');
			data.append('action[orders-create-payment]', 1);

			const res = await ajax('POST', `${ROOT}api/create-order/`, data);
			const resData = JSON.parse(res);

			if (resData.result === 'success') {
				$BODY
					.find('.order')
					.removeClass('-status-approved')
					.addClass('-status-paid')
					.find('.status__label')
					.text('Paid');

					// Wait until the email has been sent before marking as complete
					loading(false);

					result.textContent = 'Payment successful, please check your inbox for your payment receipt.';
					result.classList.add('-success');
					result.classList.remove('-danger');
					result.classList.remove('d-none');
					btn.disabled = true;
			} else {
				showError('An error has occurred, please contact Blueskin to confirm the order.');
				console.error('something went wrong');
				console.log(resData);
			}
		}

		// Show the customer the error from Stripe if their card fails to charge
		function showError(errorMsgText) {
			loading(false);

			result.textContent = errorMsgText;
			result.classList.add('-danger');
			result.classList.remove('-success');
			result.classList.remove('d-none');
		}

		function loading(isLoading) {
			if (isLoading) {
				btn.disabled = true;
				btn.classList.add('-loading');
			} else {
				btn.disabled = false;
				btn.classList.remove('-loading');
			}
		}
	}

	// Events
	// ----------------------------------------

	$DOC.ready(() => {
		if ($BODY.hasClass('payment-page')) {
			init();
		}
	});

	$WINDOW.on('page:load-completed', (e) => {
		if ($BODY.hasClass('payment-page')) {
			init();
		}
	});

	$BODY.on('change', '.payment__voucher input', function () {
		const self = $(this);
		const vouchers = ($BODY.find('.payment__voucher input:checked').length) ? $BODY.find('.payment__voucher input:checked') : false;

		init(vouchers);
	});
})();
